import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";

export default function GenderPie({ data }) {
  if (!data || data.length === 0) return <div className="bg-white p-6 rounded-xl shadow">ไม่มีข้อมูล</div>;

  return (
    <div className="bg-white p-6 rounded-xl shadow">
      <h3 className="font-semibold mb-4">สัดส่วนตามเพศ</h3>

      <ResponsiveContainer width="100%" height={240}>
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            nameKey="name"
            innerRadius={60}
            outerRadius={90}
          >
            {data.map((d, i) => (
              <Cell key={i} fill={d.color} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>

      <div className="flex justify-center gap-4 mt-4 text-sm">
        {data.map((d, i) => (
          <div key={i} style={{ color: d.color }}>
            {d.name}: {d.percent}%
          </div>
        ))}
      </div>
    </div>
  );
}
